<app-base-dialog
    [type]="type"
    [headerClass]="'text-center'"
    [isLabel]="true"
    [isButtonCancel]="true"
/>